<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oe7054/tc-custom/9781468313475.jpg?1728954778079" alt="This image is the cover for the book Forbidden Love in St. Petersburg"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forbidden Love in St. Petersburg
      </h1>
      <p class="bookDescription body article font2">
        <b>“Convincing tradecraft, coupled with a plausible look at the inner life of a spy with a license to kill, will remind readers of the best of John le Carré.” —<i>Publishers Weekly</i> (starred review)</b><br/>  <br/> Yogev Ben-Ari has been sent to St. Petersburg by the Mossad, ostensibly to network and set up business connections. His life is solitary, ordered, and lonely—until he meets Anna. Neither is quite what they seem to be, but while her identity may be mysterious, there is no doubt about the love they feel for each other.<br/>  <br/> But the impassioned affair is not part of the Mossad plan. The agency must hatch a dark scheme to drive the lovers apart. Soon what began as a quiet, solitary mission becomes a perilous exercise in survival, and Ben-Ari has no time to discover the truth about Anna’s identity before his employers act . . .<br/>  <br/> “The novel has a solid sense of intrigue and suspense, and its depiction of the world of international espionage feels accurate (as it should, since the author is a former Mossad agent). The characterizations are precise, too: these aren’t stick figures in a spy story but real people in a real environment. A nice blend of classic spy-novel conventions with a thoroughly contemporary setting.” —<i>Booklist</i> (starred review) 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mishka Ben-David
      </h2>
      
      <p class="authorDescription body article">Mishka Ben-David holds an MA in comparative literature from the University of Wisconsin and a PhD in Hebrew literature from the Hebrew University of Jerusalem. Ben-David served in the Mossad for twelve years, becoming a high-ranking officer, and he is now a full-time novelist living outside Jerusalem.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ec1664c